export const cilSpaceBar = ["24 24","<path d='M21.75 19.5h-19.875v-6h1.5v4.5h16.875v-4.5h1.5v6z'></path>"]